import React from "react";
import {FormattedMessage} from "react-intl";

const summaryPageSteps = [
  {
    target: '#summary-merlin',
    id: 'summary.assistant.intro-step',
    disableBeacon: true,
    placement: 'top'
  },
  {
    target: '.product',
    id: 'summary.assistant.howTo-step',
    disableBeacon: true,
  },
  {
    target: '.cart-btn',
    id: 'summary.assistant.apply-step',
    disableBeacon: true,
  },
  {
    target: '.socialActions',
    id: 'summary.assistant.social-step',
    disableBeacon: true
  },
];

export default summaryPageSteps;
